export default function () {

    const MAX_FONT_SIZE = 110;

    const FONTS = [
        'Bebas Neue',
        'Anton',
        'Oswald',
        'Barlow Condensed',
        'Montserrat',
        'Raleway',
        'Poppins',
        'Roboto',
        'Open Sans',
        'Permanent Marker',
    ];

    const state = {
        textAlign:      'start',
        mirror:         false,
        letterDistance: 0,
        lineDistance:   120,
        fontFamily:     '',
        fillColor:      '#000000',
        dimensions:     { width: 0, height: 0 },
    };

    const colorCode = 'M4-210';

    function fontStack() {
        return (state.fontFamily && state.fontFamily !== 'Arial')
            ? `"${state.fontFamily}", Arial, sans-serif`
            : 'Arial Black, Arial, sans-serif';
    }

    function clampedVal(el, fallback) {
        const min     = parseFloat(el.attr('min') ?? -Infinity);
        const max     = parseFloat(el.attr('max') ??  Infinity);
        const clamped = Math.min(max, Math.max(min, parseFloat(el.val()) || fallback));
        el.val(clamped);
        return clamped;
    }

    function getSummary() {
        const alignMap  = { start: 'Links', center: 'Midden', end: 'Rechts' };
        const colorLabel = jQuery('.wc__single-custom-ot-color-grid input[type="radio"]:checked').siblings('span').first().text()
                        || jQuery('.wc__single-product-information-color-grid input[type="radio"]:checked').siblings('span').first().text()
                        || '—';
        const stickerType = jQuery('[data-action="stickerMaker-color"] option:selected').text() || '—';

        return {
            'Hoogte':        state.dimensions.height + ' cm',
            'Breedte':       state.dimensions.width  + ' cm',
            'Sticker type':  stickerType,
            'Kleur':         colorLabel,
            'Lettertype':    state.fontFamily || 'Standaard',
            'Gespiegeld':    state.mirror ? 'Ja' : 'Nee',
            'Uitlijning':    alignMap[state.textAlign] || 'Links',
            'Letterafstand': state.letterDistance,
            'Regelafstand':  state.lineDistance,
        };
    }

    function renderSummary() {
        const rows = Object.entries(getSummary()).map(([label, value]) =>
            `<div class="stickermaker__summary-row u-inner-row u-gap-sb">
                <span class="stickermaker__summary-label">${label}</span>
                <span class="stickermaker__summary-value">${value}</span>
            </div>`
        ).join('');
        jQuery('[data-id="stickerMaker-summary"]').html(rows);
    }

    function refresh() {
        updateStickerPreview(jQuery('#text_area').val());
        renderSummary();
    }

    function loadGoogleFonts() {
        const query = FONTS.map(f => `family=${f.replace(/ /g, '+')}:wght@400;700;900`).join('&');
        const link  = document.createElement('link');
        link.rel    = 'stylesheet';
        link.href   = `https://fonts.googleapis.com/css2?${query}&display=swap`;
        document.head.appendChild(link);
    }

    function populateFontSelect() {
        const select = jQuery('[data-action="stickerMaker-font-family"]');
        FONTS.forEach(function (font) {
            select.append(new Option(font, font));
        });
    }

    function bindEvents() {
        jQuery('[data-action^="stickerMaker-text-align-"]').on('click', function () {
            state.textAlign = jQuery(this).data('action').replace('stickerMaker-text-align-', '');
            refresh();
        });

        jQuery('[data-action="stickerMaker-mirror-text"]').on('change', function () {
            state.mirror = jQuery(this).prop('checked');
            refresh();
        });

        jQuery('[data-action="stickerMaker-letter-distance"]').on('input', function () {
            state.letterDistance = clampedVal(jQuery(this), 0);
            refresh();
        });

        jQuery('[data-action="stickerMaker-line-distance"]').on('input', function () {
            state.lineDistance = clampedVal(jQuery(this), 120);
            refresh();
        });

        jQuery('[data-action="stickerMaker-font-family"]').on('change', function () {
            state.fontFamily = jQuery(this).val();
            if (state.fontFamily) {
                document.fonts.load(`900 60px "${state.fontFamily}"`).then(refresh);
            } else {
                refresh();
            }
        });

        jQuery('#text_area').on('input', refresh);

        let _resizeTimer = null;
        jQuery(window).on('resize', function () {
            clearTimeout(_resizeTimer);
            _resizeTimer = setTimeout(refresh, 150);
        });

        jQuery('[data-action="stickerMaker-height"]').prop('readonly', true);

        jQuery('[data-action="stickerMaker-width"]').on('change', function () {
            const newWidth = parseFloat(jQuery(this).val());
            if (!newWidth || !state.dimensions.width) return;
            state.dimensions = {
                width:  parseFloat(newWidth.toFixed(1)),
                height: parseFloat((state.dimensions.height * (newWidth / state.dimensions.width)).toFixed(1)),
            };
            updateDimensionDisplays();
            renderSummary();
        });

        jQuery(document).on('click', '[data-action="stickerMaker-atc"]', function () {
            const $btn           = jQuery(this);
            const $checkedSwatch = jQuery('.wc__single-custom-ot-color-grid input[type="radio"]:checked');
            const extraPrice     = parseFloat(jQuery('[data-action="stickerMaker-color"]').find('option:selected').attr('data-price')) || 0;
            const qty            = parseInt(jQuery('.stickermaker__display-total-quantity').val()) || 1;

            const svgEl  = document.getElementById('stickermaker-preview-svg');
            const svgStr = new XMLSerializer().serializeToString(svgEl);
            const svgDataUrl = 'data:image/svg+xml;base64,' + btoa(unescape(encodeURIComponent(svgStr)));

            $btn.addClass('is-loading').prop('disabled', true);

            jQuery.ajax({
                type: 'POST',
                url:  ajaxURL,
                data: {
                    action:          'stickermaker_add_to_cart',
                    nonce:           ajaxNonce,
                    qty:             qty,
                    text:            jQuery('#text_area').val(),
                    width:           state.dimensions.width,
                    height:          state.dimensions.height,
                    extra_price:     extraPrice,
                    font:            jQuery('[data-action="stickerMaker-font-family"]').val() || state.fontFamily,
                    mirror:          state.mirror ? 1 : 0,
                    text_align:      state.textAlign,
                    letter_distance: state.letterDistance,
                    line_distance:   state.lineDistance,
                    sticker_type:    jQuery('[data-action="stickerMaker-color"] option:selected').text(),
                    color_unique:    $checkedSwatch.attr('id')                          || '',
                    color_hex:       $checkedSwatch.data('color')                       || '',
                    color_label:     $checkedSwatch.siblings('span').first().text()     || '',
                    svg:             svgDataUrl,
                },
                success: function (response) {
                    if (response.success) {
                        window.location.href = response.data.cart_url;
                    } else {
                        alert(response.data?.message || 'Er is een fout opgetreden.');
                        $btn.removeClass('is-loading').prop('disabled', false);
                    }
                },
                error: function () {
                    alert('Er is een fout opgetreden.');
                    $btn.removeClass('is-loading').prop('disabled', false);
                },
            });
        });

        jQuery(document).on('change', '[data-action="stickerMaker-swatch-color"]', function () {
            const color = jQuery(this).data('color') || state.fillColor;
            state.fillColor = color;
            jQuery('.stickermaker__display').toggleClass('black', isLightColor(color));
            refresh();
        });

        jQuery(document).on('change', '[data-action="stickerMaker-color"]', function () {
            const $opt    = jQuery(this).find('option:selected');
            const jsonStr = $opt.attr('data-json');
            const label   = $opt.attr('data-label');
            const url     = $opt.attr('data-url');
            const type    = $opt.attr('data-type') ?? '';
            if (!jsonStr) return;

            jQuery('.product_material_link').html('').removeClass('mt-8');

            try {
                const obj       = JSON.parse(jsonStr);
                const colors    = Array.isArray(obj.colors) ? obj.colors : [];
                const thumbnail = obj.thumbnail || '';

                let $container = jQuery('.wc__single-product-information-color-grid');
                let inputName  = 'fjs_color_options';
                let html;

                if ($container.length > 0) {
                    html = colors.map((c, i) => `
                        <label for="${c.unique}" style="background-color:${c.hex};">
                          <span>${c.label}</span>
                          <input type="radio" name="fjs_color_options" id="${c.unique}"
                                 value="${c.label}" data-color="${c.hex}" data-type="${type}"
                                 data-unique="${c.unique}" data-action="stickerMaker-swatch-color"
                                 ${i === 0 ? 'checked' : ''}>
                          ${thumbnail ? `<img src="${thumbnail}" alt="">` : ''}
                        </label>`).join('');
                } else {
                    $container = jQuery('.wc__single-custom-ot-color-grid');
                    inputName  = 'stickerMaker-swatch-color';
                    const defaultUnique = colors.some(c => c.unique === colorCode ) ? colorCode : (colors[0] || {}).unique;
                    html = colors.map(c => `
                        <label for="${c.unique}" style="background-color:${c.hex};">
                          <span>${c.label}</span>
                          <input type="radio" name="stickerMaker-swatch-color" id="${c.unique}"
                                 value="${c.label}" data-color="${c.hex}" data-type="${type}"
                                 data-action="stickerMaker-swatch-color" ${c.unique === defaultUnique ? 'checked' : ''}>
                          <input type="hidden" name="stickerMaker-unique-code" value="${c.unique}">
                          ${thumbnail ? `<img src="${thumbnail}" alt="">` : ''}
                        </label>`).join('');
                }

                if ($container.length > 0) {
                    $container.html(html);

                    const $default = $container.find('input[id="' + colorCode + '"]');
                    const $first   = $default.length ? $default : $container.find(`input[name="${inputName}"]`).first();
                    if ($first.length) {
                        $first.prop('checked', true).trigger('change');
                    }


                }

                if (label && url) {
                    jQuery('.product_material_link')
                        .append(`<a class="u-inner-row u-gap-8 u-inner-align-center" href="${url}"><svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" class="feather feather-info"><circle cx="12" cy="12" r="10"></circle><line x1="12" y1="16" x2="12" y2="12"></line><line x1="12" y1="8" x2="12.01" y2="8"></line></svg> <div>Alles over <span>${label}</span></div></a>`)
                        .addClass('mt-8');
                }

                calculatePrice();
                renderSummary();
            } catch (e) {
                console.error('Invalid data-json on selected option', e);
            }
        });
    }

    function isLightColor(hex) {
        const c = hex.replace('#', '');
        const r = parseInt(c.length === 3 ? c[0] + c[0] : c.slice(0, 2), 16);
        const g = parseInt(c.length === 3 ? c[1] + c[1] : c.slice(2, 4), 16);
        const b = parseInt(c.length === 3 ? c[2] + c[2] : c.slice(4, 6), 16);
        return (r * 299 + g * 587 + b * 114) / 1000 > 200;
    }

    function fitFontSize(ctx, lines, containerWidth, maxHeight, pad) {
        const maxFontSize = MAX_FONT_SIZE;

        ctx.font = `900 ${maxFontSize}px ${fontStack()}`;
        let fontSize = maxFontSize;
        lines.forEach(function (line) {
            const textWidth60 = ctx.measureText(line).width;
            const spacing     = state.letterDistance * Math.max(0, line.length - 1);
            const room        = containerWidth - spacing;
            if (room <= 0) {
                fontSize = 1;
            } else if (textWidth60 > 0) {
                fontSize = Math.min(fontSize, Math.max(1, Math.floor(room * maxFontSize / textWidth60)));
            }
        });

        ctx.font = `900 ${fontSize}px ${fontStack()}`;
        const probeH          = ctx.measureText('HgjpqÁ');
        const rowH            = Math.ceil(probeH.actualBoundingBoxAscent) + Math.ceil(probeH.actualBoundingBoxDescent);
        const lineH           = Math.round(rowH * state.lineDistance / 100);
        const tentativeHeight = pad + (lines.length - 1) * lineH + rowH + pad;

        if (tentativeHeight > maxHeight) {
            fontSize = Math.max(1, Math.floor(fontSize * maxHeight / tentativeHeight));
        }

        return fontSize;
    }

    function measureLayout(ctx, lines, fontSize, pad) {
        ctx.font = `900 ${fontSize}px ${fontStack()}`;

        const probe      = ctx.measureText('HgjpqÁ');
        const ascent     = Math.ceil(probe.actualBoundingBoxAscent);
        const descent    = Math.ceil(probe.actualBoundingBoxDescent);
        const rowH       = ascent + descent;
        const lineHeight = Math.round(rowH * state.lineDistance / 100);

        let maxTextWidth = fontSize;
        lines.forEach(function (line) {
            const measured = Math.ceil(ctx.measureText(line).width);
            const spacing  = state.letterDistance * Math.max(0, line.length - 1);
            maxTextWidth   = Math.max(maxTextWidth, measured + spacing);
        });

        return {
            fontSize,
            lineHeight,
            baseline0: pad + ascent,
            svgWidth:  maxTextWidth,
            svgHeight: pad + (lines.length - 1) * lineHeight + rowH + pad,
        };
    }

    function renderLines(svgEl, lines, layout) {
        const svgNS     = 'http://www.w3.org/2000/svg';
        const anchorMap = { start: 'start', center: 'middle', end: 'end' };
        const xMap      = { start: 0, center: layout.svgWidth / 2, end: layout.svgWidth };
        const anchor    = anchorMap[state.textAlign] || 'start';
        const xPos      = xMap[state.textAlign]      || 0;

        lines.forEach(function (line, i) {
            const textEl = document.createElementNS(svgNS, 'text');
            textEl.setAttribute('x', xPos);
            textEl.setAttribute('y', layout.baseline0 + i * layout.lineHeight);
            textEl.setAttribute('text-anchor', anchor);
            textEl.setAttribute('font-size', layout.fontSize);
            textEl.setAttribute('font-family', fontStack());
            textEl.setAttribute('font-weight', '900');
            textEl.setAttribute('fill', state.fillColor);
            if (state.letterDistance !== 0) {
                textEl.setAttribute('letter-spacing', state.letterDistance);
            }
            textEl.textContent = line;
            svgEl.appendChild(textEl);
        });
    }

    function updateActiveStates(multiLine) {
        jQuery('.stickermaker__display-regelafstand').toggleClass('is-active', multiLine);
        jQuery('.stickermaker__display-alignment-text').toggleClass('is-active', multiLine);
        jQuery('[data-action^="stickerMaker-text-align-"]').each(function () {
            const isActive = multiLine && jQuery(this).data('action') === 'stickerMaker-text-align-' + state.textAlign;
            jQuery(this).toggleClass('is-active', isActive);
        });
    }

    function updateDimensionDisplays() {
        jQuery('[data-action="stickerMaker-width"]').val(state.dimensions.width);
        jQuery('[data-action="stickerMaker-height"]').val(state.dimensions.height);
        jQuery('[data-id="stickerMaker-width"]').text(state.dimensions.width + ' cm');
        jQuery('[data-id="stickerMaker-height"]').text('~ ' + state.dimensions.height + ' cm');
        calculatePrice();
    }

    let _priceXhr         = null;
    let _priceDebounce    = null;
    let _priceInitialized = false;

    function calculatePrice() {
        if (!_priceInitialized) {
            _priceInitialized = true;
            return;
        }
        clearTimeout(_priceDebounce);
        _priceDebounce = setTimeout(_sendPriceRequest, 500);
    }

    function _sendPriceRequest() {
        if (_priceXhr) {
            _priceXhr.abort();
            _priceXhr = null;
        }

        const $price     = jQuery('[data-id="stickerMaker-price"]');
        const extraPrice = parseFloat(jQuery('[data-action="stickerMaker-color"]').find('option:selected').attr('data-price')) || 0;

        $price.addClass('updating');

        _priceXhr = jQuery.ajax({
            type: 'POST',
            url:  ajaxURL,
            data: {
                action:  'stickermaker_calculate_price',
                nonce:   ajaxNonce,
                width:   state.dimensions.width,
                height:  state.dimensions.height,
                extras:  extraPrice ? [extraPrice] : [],
            },
            success: function (response) {
                if (response.success) {
                    $price.html(response.price);
                }
            },
            complete: function () {
                _priceXhr = null;
                $price.removeClass('updating');
            },
        });
    }

    function updateStickerPreview(text) {
        const jQuerysvg = jQuery('#stickermaker-preview-svg');
        if (!jQuerysvg.length) return;

        const lines = text.slice(0, 1000).split('\n').filter(function (line) { return line.length > 0; });
        if (!lines.length) return;

        const pad            = 2;
        const containerWidth = jQuerysvg.closest('.container').width() || 1230;
        const ctx            = document.createElement('canvas').getContext('2d');

        // Display layout: scaled down to fit the screen
        const displayFontSize = fitFontSize(ctx, lines, containerWidth, 400, pad);
        const displayLayout   = measureLayout(ctx, lines, displayFontSize, pad);

        // Natural layout: always at MAX_FONT_SIZE — screen size doesn't affect reported dimensions
        const naturalLayout = measureLayout(ctx, lines, MAX_FONT_SIZE, pad);

        jQuerysvg.attr('width',   displayLayout.svgWidth);
        jQuerysvg.attr('height',  displayLayout.svgHeight);
        jQuerysvg.attr('viewBox', `0 0 ${displayLayout.svgWidth} ${displayLayout.svgHeight}`);
        jQuerysvg.find('text').remove();

        renderLines(jQuerysvg[0], lines, displayLayout);
        jQuerysvg.css('transform', state.mirror ? 'scaleX(-1)' : '');

        const PX_PER_CM = 96 / 2.54;
        state.dimensions = {
            width:  parseFloat((naturalLayout.svgWidth  / PX_PER_CM).toFixed(1)),
            height: parseFloat((naturalLayout.svgHeight / PX_PER_CM).toFixed(1)),
        };
        updateDimensionDisplays();

        updateActiveStates(lines.length > 1);
    }

    loadGoogleFonts();
    populateFontSelect();
    bindEvents();
    refresh();

    // Populate swatches on first load
    const $firstColorSelect = jQuery('[data-action="stickerMaker-color"]').first();
    if ($firstColorSelect.length) {
        $firstColorSelect.trigger('change');
    }

}